import { useContext } from 'react';

import useFetch from '../services/apiService/useFetch';
import { LiveClassContext } from '../globalContext/liveClasses/liveClassesProvider';
import API_ENDPOINTS from '../consts/endpoint';
import { setCurrentChapterClassDetails } from '../globalContext/liveClasses/liveClassesActions';
import { API_RESPONSE_STATUS_CODE } from '../consts/constants';

const useSaveCurrentChapter = () => {
  const [, liveClassDispatch] = useContext(LiveClassContext);

  const { fetchData: getCurrentChapterInfo } = useFetch({
    url: `${API_ENDPOINTS.SESSIONS}`,
    otherOptions: {
      skipApiCallOnMount: true,
    },
  });

  const saveCurrentChapterDetails = async ({
    subject_id,
  }: {
    subject_id: number;
  }) => {
    const currentChapterResponse = await getCurrentChapterInfo({
      queryParamsObject: {
        time_frame: 'past',
        limit: 1,
        sort_order: 'desc',
        subject_id,
      },
    });
    if (currentChapterResponse?.status === API_RESPONSE_STATUS_CODE.SUCCESS) {
      liveClassDispatch(
        setCurrentChapterClassDetails({
          currentChapterDetails: currentChapterResponse?.data,
        }),
      );
    }
  };

  return { saveCurrentChapterDetails };
};

export default useSaveCurrentChapter;
